import { useQuery, useQueryClient } from '@tanstack/react-query';
import { getClinicMasterProducts } from '../requests';

export const useClinicMasterProducts = (clinicId: string, page: number, limit: number) => {
  const { data, isLoading, refetch, isFetched } = useQuery({
    queryFn: () => getClinicMasterProducts(clinicId, page, limit),
    queryKey: ['clinic-master-products', clinicId, page, limit]
  });

  return {
    clinicMasterProducts: data?.data.data || [],
    isLoading,
    isLoaded: isFetched,
    refetch,
    total: data?.data.pagination?.total
  };
};

export const useRemoveCachedClinicMasterProducts = () => {
  const queryClient = useQueryClient();

  return () => {
    queryClient.removeQueries({
      queryKey: ['clinic-master-products'],
    });
  };
};
